

import Collection from 'ol/Collection';
import Style from 'ol/style/Style';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Circle from 'ol/style/Circle';
import XYZ from 'ol/source/XYZ';
import TileArcGISRest from 'ol/source/TileArcGISRest';
import ImageArcGISRest from 'ol/source/ImageArcGISRest';
import ImageWMS from 'ol/source/ImageWMS';
import VectorSrc from 'ol/source/Vector';
import Tile from 'ol/layer/Tile';
import Image from 'ol/layer/Image';
import Vector from 'ol/layer/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import vectorStyleCreator from './vector-style';
import xhr from 'xhr';
import EsriJSON from 'ol/format/EsriJSON.js';
import {tile, bbox} from 'ol/loadingstrategy';
import TileGrid from 'ol/tilegrid/TileGrid';
import {createXYZ} from 'ol/tilegrid';

import MVT from 'ol/format/MVT';
import VectorTileLayer from 'ol/layer/VectorTile';
import VectorTileSource from 'ol/source/VectorTile';
import Icon from 'ol/style/Icon';
import createMapboxStreetsV6Style from './mapbox-streets-style';
import find from 'lodash/find';

const esrijsonFormat = new EsriJSON();

const origin = window.location.origin;
const esriScale = {
  0:{
      ID: 0,
      RESOLUTION: 156543.03392800014,
      SCALE: 5.91657527591555E8
  },
  1:{
      ID: 1,
      RESOLUTION: 78271.51696399994,
      SCALE: 2.95828763795777E8
  },
  2:{
      ID: 2,
      RESOLUTION: 39135.75848200009,
      SCALE: 1.47914381897889E8
  },
  3:{
      ID: 3,
      RESOLUTION: 19567.87924099992,
      SCALE: 7.3957190948944E7
  },
  4:{
      ID: 4,
      RESOLUTION: 9783.93962049996,
      SCALE: 3.6978595474472E7
  },
  5:{
      ID: 5,
      RESOLUTION: 4891.96981024998,
      SCALE: 1.8489297737236E7
  },
  6:{
      ID: 6,
      RESOLUTION: 2445.98490512499,
      SCALE: 9244648.868618
      
  },
  7:{
      ID: 7,
      RESOLUTION: 1222.992452562495,
      SCALE: 4622324.434309
  },
  8:{
      ID: 8,
      RESOLUTION: 611.4962262813797,
      SCALE: 2311162.217155
  },
  9:{
      ID: 9,
      RESOLUTION: 305.74811314055756,
      SCALE: 1155581.108577
  },
  10:{
      ID: 10,
      RESOLUTION: 152.87405657041106,
      SCALE: 577790.554289
  },
  11:{
      ID: 11,
      RESOLUTION: 76.43702828507324,
      SCALE: 288895.277144
  },
  12:{
      ID: 12,
      RESOLUTION: 38.21851414253662,
      SCALE: 144447.638572
  },
  13: {
      ID: 13,
      RESOLUTION: 19.10925707126831,
      SCALE: 72223.819286
  },
  14: {
      ID: 14,
      RESOLUTION: 9.554628535634155,
      SCALE: 36111.909643
  },
  15: {
      ID: 15,
      RESOLUTION: 4.77731426794937,
      SCALE: 18055.954822
  },
  16: {
      ID: 16,
      RESOLUTION: 2.388657133974685,
      SCALE: 9027.977411
  },
  17: {
      ID: 17,
      RESOLUTION: 1.1943285668550503,
      SCALE: 4513.988705
  },
  18:{
      ID: 18,
      RESOLUTION: 0.5971642835598172,
      SCALE: 2256.994353
  },
  19:{
      ID: 19,
      RESOLUTION: 0.29858214164761665,
      SCALE: 1128.497176
  },
  20:{
      ID: 20,
      RESOLUTION: 0.14929107082380833,
      SCALE: 564.248588
  },
  21:{
      ID: 21,
      RESOLUTION: 0.07464553541190416,
      SCALE: 282.124294
  },
  22:{
      ID: 22,
      RESOLUTION: 0.03732276770595208,
      SCALE: 141.062147
  },
  23: {
      ID: 23,
      RESOLUTION: 0.01866138385297604,
      SCALE: 70.5310735
  }

}
const isCrossOrigin = (url) => {
  if(!!window.MSInputMethodContext && !!document.documentMode) return null;
  if(url){
    if(url.indexOf(origin) === -1) return 'anonymous';
  }else{
    return null;
  }
}

// const defaultVectorStyle = new Style({
//   fill: new Fill({
//     color: 'rgba(255, 255, 255, 0.2)'
//   }),
//   stroke: new Stroke({
//     color: 'rgba(0, 0, 0, 0.5)',
//     lineDash: [10, 10],
//     width: 2
//   }),
//   image: new Circle({
//     radius: 3,
//     stroke: new Stroke({
//       color: 'rgba(0, 0, 0, 0.7)'
//     }),
//     fill: new Fill({
//       color: 'rgba(255, 255, 255, 0.2)'
//     })
//   })
// });

function formatLabeledUrl(url){
  const delim = url.indexOf('?') === -1 ? '?' : '&';
  return `${url}${delim}label=true`;
}

function getXyzSource(options){
  const labelsOn = !!options.labelDefault;
  const url = labelsOn ? formatLabeledUrl(options.url) : options.url;
  return new XYZ({
    url: url,
    // crossOrigin: isCrossOrigin(options.url)
  })
}

function getArcGISTiledSource(options){
  return new TileArcGISRest({
    url: options.url,
    params: {
      LAYERS: 'show:' + options.layerList
    },
    // crossOrigin: isCrossOrigin(options.url)
  })
}

function getArcGISImageSource(options){
  const params = options.params || {};

  if(options.layer) params.LAYERS = options.layer;

  if(options.layerList) params.LAYERS = options.layerList;

  if(options.filter) {
    Object.keys(options.filter).forEach((key) => {
      params[key] = options.filter[key];
    })
  }

  return new ImageArcGISRest({
    ratio: 1,
    url: options.url,
    params: params,
    
    // crossOrigin: isCrossOrigin(options.url)
  })
}

function getTileWmsSource(options){
  return new XYZ({
    url: options.serviceURL
  })
}

function getWmsSource(options){
  const params = options.params || {};

  if(options.layer) params.LAYERS = options.layer;

  if(options.layerList) params.LAYERS = options.layerList;

  if(options.filter) {
    Object.keys(options.filter).forEach((key) => {
      params[key] = options.filter[key];
    })
  }

  return new ImageWMS({
    url: options.url,
    params: params,
    // crossOrigin: isCrossOrigin(options.url)
  })
}

function getLocalVectorSource(options){
  return new VectorSrc({
    features: options.features
  })
}

function getRemoteVectorSource(options){
  const src = new VectorSrc({
    format: new GeoJSON(),
    url: options.url
  })
  src.on('addfeature', (e) => {
    const uid = options.uid;
    const g = new GeoJSON();
    const geojson = g.writeFeatureObject(e.feature, { featureProjection: 'EPSG:3857', dataProjection: 'EPSG:4326' });
    window.store.doGeojsonIdentAddFeatures(uid, geojson);
  })
  return src;
}

function getEsriVectorSource(options){
  let serviceUrl = options.url;
  const layer = options.layerList;
  const trailingSlashMatch = /\/$/;

  if(!trailingSlashMatch.test(serviceUrl)) serviceUrl += '/';
  
  const src = new VectorSrc({
    loader: function(extent, resolution, projection) {
      
      const g = encodeURIComponent(`{"xmin":${extent[0]},"ymin":${extent[1]},"xmax":${extent[2]},"ymax":${extent[3]},"spatialReference":{"wkid":102100}}`);
      const url = `${serviceUrl}${layer}/query/?f=json&returnGeometry=true&spatialRel=esriSpatialRelIntersects&geometry=${g}&geometryType=esriGeometryEnvelope&inSR=102100&outFields=*&outSR=102100`;
       
      xhr.get(url, (err, response, body) => {
        if(err) return console.log(err);
        const data = JSON.parse(body);
        const features = esrijsonFormat.readFeatures(data, { featureProjection: projection });
        if (features.length > 0) {
          src.addFeatures(features);
        }
      })    
    },
    
    strategy: tile(
      createXYZ({
        tileSize: 512        
      })
    )
  });
  return src;
}

function getVectorTileSource(options){
  const src = new VectorTileSource({      
        format: new MVT(),
        url: options.url
      })
      
  return src;
}

function getTileLayer(options, source){
 return new Tile({
  source: source,
  visible: options.visible,
  zIndex: options.zIndex || 0,
  opacity: options.opacity || 1
 })
}


function getImageLayer(options, source){
  return new Image({
    source: source,
    visible: options.visible,
    zIndex: options.zIndex || 0,
    opacity: options.opacity || 1
  })
}

function getLocalVectorLayer(options, source){
  return new Vector({
    altitudeMode: 'clampToGround',
    source: source,
    visible: options.visible,
    style: vectorStyleCreator(options),
    zIndex: options.zIndex || 0,
    opacity: options.opacity || 1
  })
}

function getRemoteVectorLayer(options, source){
  const lyr = new Vector({
    altitudeMode: 'clampToGround',
    source: source,
    visible: options.visible,
    style: vectorStyleCreator(options),
    zIndex: options.zIndex || 0,
    opacity: options.opacity || 1
  })
  const uid = options.uid;
  window.store.doGeojsonIdentAddFeatures(uid, null, lyr);
  return lyr;
}

function getVectorTileLayer(options, source) {
  return new VectorTileLayer({
    // declutter: true,
    altitudeMode: 'clampToGround',
    visible: options.visible,
    zIndex: options.zIndex || 0,
    opacity: options.opacity || 1,
    source: source,
    style: createMapboxStreetsV6Style(Style, Fill, Stroke, Icon, Text, Circle)
  });
}

function getEsriVectorLayer(options, source){
  const layerInfo = options.layerInfo
  let minZoom;
  if(layerInfo && layerInfo.minScale) {
    const minZoomObj= find(esriScale, function(o) { return o.SCALE <= layerInfo.minScale; })
    minZoom =minZoomObj.ID;
  }
  const lyr = new Vector({
    altitudeMode: 'clampToGround',
    source: source,
    minZoom: minZoom,
    visible: options.visible,
    style: vectorStyleCreator(options),
    zIndex: options.zIndex || 0,
    opacity: options.opacity || 1
  });
  return lyr;
}

function getSource(options){
  switch (options.serviceType){
    case 'XYZ' : 
      return getXyzSource(options);
    case 'ArcGIS' :
      return getArcGISTiledSource(options);
    case 'ArcGISImage' :
      return getArcGISImageSource(options);
    case 'TileWMS' :
      return getTileWmsSource(options);
    case 'WMS' :
      return getWmsSource(options);
    case 'VECTOR':
    case 'LocalVector' : 
      return getLocalVectorSource(options);
    case 'MVT' :
      return getVectorTileSource(options);
    case 'RemoteVector' :
      return getRemoteVectorSource(options);
    case 'EsriFeatureService' :
      return getEsriVectorSource(options);
    default: 
      return null;
  }
}

function getLayer(options, source){
  if(!source) source = getSource(options);
  switch(options.serviceType){
    case 'XYZ' :
      return getTileLayer(options, source);
    case 'ArcGIS' :
      return getTileLayer(options, source);
    case 'ArcGISImage' :
      return getImageLayer(options, source);
    case 'TileWMS' :
      return getTileLayer(options, source);
    case 'WMS' :
      return getImageLayer(options, source);
    case 'VECTOR':
    case 'LocalVector' : 
      return getLocalVectorLayer(options, source);
    case 'LocalVectorTileLayer':
      return getVectorTileLayer(options, source);
    case 'RemoteVector' :
      return getRemoteVectorLayer(options, source);
    case 'MVT' :
      return getVectorTileLayer(options, source);
    case 'EsriFeatureService' :
      return getEsriVectorLayer(options, source);
    default: 
      return null;
  }
}

export { getSource, getLayer };